<template>
  <div v-if="!$store.getters.token">
    <b-modal
      v-if="mode === 'modal'"
      id="modal_login_box"
      ref="modal_login_box"
      modal-class="modal_login_box"
      header-class="modal-header justify-content-center align-items-center border-bottom-0"
      content-class=""
      footer-class=""
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-hidden="true"
      hide-footer
    >
      <template v-slot:modal-header>
        <h4 class="text-white mb-0">
          <b>{{ $t("Bao.login") }}</b>
        </h4>
        <button type="button" class="close rounded-circle m-0" @click="$bvModal.hide('modal_login_box')">
          <i class="icon-clear" />
        </button>
      </template>
      <div>
        <div class="float_register_form mb-20">
          <ul class="float_register_tabs d-flex list-unstyled">
            <li><a class="d-block text-center" :class="{ 'active': (loginType==='username') }" @click="switchLoginType('username')"><b>{{ $t("Bao.username") }}</b></a></li>
            <li><a class="d-block text-center" :class="{ 'active': (loginType==='phone') }" @click="switchLoginType('phone')"><b>{{ $t("Bao.phone") }}</b></a></li>
          </ul>
          <div v-if="loginType==='username'" class="form-group mb-10">
            <div class="position-relative">
              <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="12" height="14.633" viewBox="0 0 12 14.633">
                <g opacity="0.8">
                  <path d="M44.8,528.8c-3.313,0-6,2.263-6,5.056a1.864,1.864,0,0,0,2,1.685h8a1.863,1.863,0,0,0,2-1.685C50.8,531.064,48.113,528.8,44.8,528.8Z" transform="translate(-38.8 -520.908)" fill="#171B22" />
                  <path d="M269.4,13.679A3.679,3.679,0,1,0,273.079,10,3.678,3.678,0,0,0,269.4,13.679Z" transform="translate(-267.079 -10)" fill="#171B22" />
                </g>
              </svg>
              <input
                v-model="postForm.username"
                v-validate="'required'"
                class="float_register_ipt w-100 vti__input text-black"
                :placeholder="$t('Bao.please_input') + $t('Bao.username')"
                type="text"
                name="username"
                :data-vv-as="$t('Bao.username')"
                autocomplete="off"
              >
              <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
            </div>
          </div>
          <div v-else class="form-group mb-10">
            <vue-tel-input
              v-model="postForm.username"
              v-validate="'required'"
              class="form_ipt_tel"
              :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
              name="username"
              :data-vv-as="$t('Bao.phone')"
              :only-countries="countryList"
              :default-country="defaultCountry"
              mode="international"
              :required="true"
              autocomplete="off"
            />
            <small v-if="errors.has('username')" class="help-block">{{ errors.first('username') }}</small>
          </div>
          <div class="form-group mb-0">
            <div class="position-relative">
              <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="12" height="14.667" viewBox="0 0 12 14.667">
                <g opacity="0.8">
                  <path d="M102.433,16.667h5.334v-2a2.667,2.667,0,0,0-5.334,0v2Zm8.667,1v6a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1h.334v-2a4.667,4.667,0,0,1,9.333,0v2h.334a1,1,0,0,1,1,1Z" transform="translate(-99.1 -10)" fill="#171B22" />
                </g>
              </svg>
              <input
                v-model="postForm.password"
                v-validate="'required'"
                class="float_register_ipt w-100 text-black"
                type="password"
                :placeholder="$t('Bao.please_input') + $t('Bao.password')"
                name="passwordz"
                :data-vv-as="$t('Bao.password')"
                autocomplete="new-password"
              >
              <!-- passwordz 欺騙瀏覽器避免自動填入 並改變樣式 -->
              <small v-if="errors.has('passwordz')" class="help-block">{{ errors.first('passwordz') }}</small>
              <small v-if="errors.has('password')" class="help-block">{{ errors.first('password') }}</small>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center border-top-0 mb-0 p-0">
          <div class="wallet_transfer_btn w-100 m-0">
            <div class="wallet_transfer_btn d-flex justify-content-center mb-10">
              <button class="btn btn_login_game btn_register text-white border-0 w-100 p-10" :disabled="actionLoading" type="button" @click="clickLogin()">
                {{ $t("Bao.login") }}
                <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
              </button>
              <button class="btn btn_free_register btn_register text-white border-0 w-100 p-10" type="button" @click="$bvModal.show('modal_register_box')">
                {{ $t("Bao.register") }}
              </button>
            </div>
            <button class="btn btn_forget_password btn_register text-white border-0 w-100 p-10" type="button" @click="$router.push('/user/forget')">
              {{ $t("Bao.forget_password") }}
            </button>
          </div>
        </div>
      </div>
    </b-modal>
    <div v-if="mode === 'float' && $store.state.brand.permissionInfo.enable_left_login" class="float_register_block d-flex align-items-center position-absolute w-100 h-100">
      <div class="float_register_inner mx-auto">
        <form class="float_register_form mb-0" autocomplete="off">
          <h6 class="float_register_title text-white text-center mb-20 pb-20">
            {{ $t("Bao.login") }}
          </h6>
          <ul class="float_register_tabs d-flex list-unstyled">
            <li><a class="d-block text-center text-white" :class="{ 'active': (loginType==='username') }" @click="switchLoginType('username')"><b>{{ $t("Bao.username") }}</b></a></li>
            <li><a class="d-block text-center text-white" :class="{ 'active': (loginType==='phone') }" @click="switchLoginType('phone')"><b>{{ $t("Bao.phone") }}</b></a></li>
          </ul>
          <div v-if="loginType==='username'" class="form-group mb-10">
            <div class="position-relative">
              <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="12" height="14.633" viewBox="0 0 12 14.633">
                <g opacity="0.8">
                  <path d="M44.8,528.8c-3.313,0-6,2.263-6,5.056a1.864,1.864,0,0,0,2,1.685h8a1.863,1.863,0,0,0,2-1.685C50.8,531.064,48.113,528.8,44.8,528.8Z" transform="translate(-38.8 -520.908)" fill="#fff" />
                  <path d="M269.4,13.679A3.679,3.679,0,1,0,273.079,10,3.678,3.678,0,0,0,269.4,13.679Z" transform="translate(-267.079 -10)" fill="#fff" />
                </g>
              </svg>
              <input
                v-model="postForm.username"
                v-validate="'required'"
                class="float_register_ipt w-100"
                :placeholder="$t('Bao.please_input') + $t('Bao.username')"
                type="text"
                name="username"
                :data-vv-as="$t('Bao.username')"
                autocomplete="off"
              >
              <p v-if="errors.has('username')" class="input-error-tip">
                {{ errors.first('username') }}
              </p>
              <p v-else class="input-error-tip">
&nbsp;
              </p>
            </div>
          </div>
          <div v-else class="form-group mb-10">
            <vue-tel-input
              v-model="postForm.username"
              v-validate="'required'"
              class="form_ipt_tel"
              :placeholder="$t('Bao.please_input')+$t('Bao.phone')"
              name="username"
              :data-vv-as="$t('Bao.phone')"
              :only-countries="countryList"
              :default-country="defaultCountry"
              mode="international"
              :required="true"
              autocomplete="off"
            />
            <p v-if="errors.has('username')" class="input-error-tip">
              {{ errors.first('username') }}
            </p>
            <p v-else class="input-error-tip">
&nbsp;
            </p>
          </div>
          <div class="form-group mb-30">
            <div class="position-relative">
              <svg class="position-absolute" xmlns="http://www.w3.org/2000/svg" width="12" height="14.667" viewBox="0 0 12 14.667">
                <g opacity="0.8">
                  <path d="M102.433,16.667h5.334v-2a2.667,2.667,0,0,0-5.334,0v2Zm8.667,1v6a1,1,0,0,1-1,1h-10a1,1,0,0,1-1-1v-6a1,1,0,0,1,1-1h.334v-2a4.667,4.667,0,0,1,9.333,0v2h.334a1,1,0,0,1,1,1Z" transform="translate(-99.1 -10)" fill="#fff" />
                </g>
              </svg>
              <input
                v-model="postForm.password"
                v-validate="'required'"
                class="float_register_ipt w-100"
                type="password"
                :placeholder="$t('Bao.please_input') + $t('Bao.password')"
                name="passwordz"
                :data-vv-as="$t('Bao.password')"
                autocomplete="new-password"
              >
              <p v-if="errors.has('passwordz')" class="input-error-tip">
                {{ errors.first('passwordz') }}
              </p>
              <p v-else-if="errors.has('password')" class="input-error-tip">
                {{ errors.first('password') }}
              </p>
              <p v-else class="input-error-tip">
&nbsp;
              </p>
            </div>
          </div>
          <div class="form-group mb-10">
            <button class="btn btn_login_game btn_register text-white border-0 w-100 p-5" type="button" :disabled="actionLoading" @click="clickLogin()">
              {{ $t("Bao.login") }}
              <i v-show="actionLoading" class="fa fa-spinner fa-pulse fa-fw" />
            </button>
          </div>
          <div class="form-group mb-10">
            <button class="btn btn_free_register btn_register text-white border-0 w-100 p-5" type="button" @click="$bvModal.show('modal_register_box')">
              <b>{{ $t("Bao.register") }}</b>
            </button>
          </div>
          <div class="form-group mb-0">
            <div class="d-flex justify-content-end">
              <router-link class="d-block link_forget" to="/user/forget">
                {{ $t("Bao.forget_password") }}
              </router-link>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { VueTelInput } from 'vue-tel-input'
import { login } from '@/api/user'
import { login as localLogin } from '@/utils/user'
import { setErrorMessage } from '@/utils/tool'

export default {
  components: {
    VueTelInput
  },
  props: {
    'mode': {
      type: String,
      default: 'modal' // modal, float
    }
  },
  data() {
    const postForm = {
      username: null,
      telephone: null,
      password: null,
      captcha: null
    }
    return {
      loginType: 'username', // username, phone
      postForm,
      countryList: [],
      defaultCountry: '',
      actionLoading: false
    }
  },
  created() {
    this.countryList = this.$store.getters.supportPhoneCode
    this.defaultCountry = this.countryList[0]
  },
  methods: {
    switchLoginType(loginType) {
      this.loginType = loginType
    },
    clickLogin() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.actionLoading = true
          login(this.postForm).then(response => {
            let redirect = 'index'
            if (this.$store.getters.inviteCode !== null) {
              redirect = 'user'
            }
            this.$store.commit('SET_READ_TERMS', false)
            localLogin(response.data.data, redirect)
          }).catch((error) => {
            setErrorMessage(error.response, this.errors)
          }).finally((e) => {
            this.actionLoading = false
          })
        }
      })
    }
  }
}
</script>

<style>
.float_register_block .float_register_form .form-group .vue-tel-input .vti__dropdown .vti__dropdown-list.below {
  width: 600%;
}

.float_register_form .form-group .vue-tel-input .vti__dropdown .vti__dropdown-list.below {
  width: 600% !important;
}

.float_register_block .vti__input {
  color: white;
}

.text-black {
  color: black !important;
}
</style>
